import { Component, Input, OnInit } from "@angular/core";
import { GenericService } from "../../services/generic.service";
import { AggregationService } from "../../services/aggregation.service";
import { AnalyticService } from "../../services/analytic.service";
import * as platFormLib from "../../implconfig/aggrConfig";

@Component({
  selector: "app-dycomponent",
  templateUrl: "./dynamicComponent.html",
  styleUrls: ["./dynamicComponent.scss"]
})
export class DynamicComponent implements OnInit {
  @Input() templateName: string;
  @Input() serviceURL: string;
  @Input() serviceName: string;
  @Input() entitlement: string;
  @Input() shouldAggregate: string;
  @Input() isAggregationBucket: string;
  tname: string;
  dataServiceObj: any;
  dataServiceError: any;
  testData: string[];
  genericAggregator: any;
  aggrObj: any;
  tooltipTitle: string;
  tooltipContent: string;
  aggVal: any;
  public contractSummary: any;
  tempStyleUrl: string;
  pruDataType: string;
  appName: string;
  redesign: boolean = false;
  /**
   *
   * @param _genericService
   * Description: Initialize the service object.
   */
  constructor(
    private _genericService: GenericService,
    private _aggregationService: AggregationService,
    private _analyticService: AnalyticService
  ) {
    this.aggVal = [];
    this.contractSummary = [];
    this.dataServiceObj = null;
    this.dataServiceError = null;
    this.tooltipTitle = "Tooltip Title";
    this.tooltipContent = "Tooltip Content";
  }

  /**
   * Description: ngOnInit to call the service and load the url
   * loader for the application.
   */
  ngOnInit(): void {
    // if (this.dtype === 'json') {
    this._genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
    });
    if (this.serviceURL) {
      this._genericService
        .getServiceData(this.serviceURL, this.serviceName)
        .subscribe(
          serviceData => {
            if (parseInt(serviceData["responseCode"]) === 403) {
              this._genericService.callUiLogger(serviceData["responseStatus"]);
            }

            if (
              this.shouldAggregate === "Y" ||
              this.isAggregationBucket === "true"
            ) {
              this.genericAggregator = new platFormLib[
                this._genericService.appTitle
              ](this._genericService.appTitle);
              this.genericAggregator.aggregationImpl(
                serviceData,
                this.shouldAggregate,
                this._genericService,
                this._aggregationService,
                this.isAggregationBucket,
                this._analyticService
              );
              this.dataServiceObj = serviceData;
            } else {
              this.dataServiceObj = serviceData;
            }
            this.dataServiceObj.businessUnit = this.entitlement;
          },
          error => {
            if (error.status < 200 || error.status >= 305) {
              // this._genericService.updateFallBackFlag(true);
              this.dataServiceObj = { responseCode: error.status, businessUnit: this.entitlement };
              console.log("contractsummary error: ", this.dataServiceObj);
            }
            // else if (error.status === 403){
            //   this._genericService.callUiLogger('no response');
            // }
            //this._aggregationService.aggregationDone.next('aggregationDone');
            this._aggregationService.emitAggDone();
            //this._genericService.updateSpinner();
          }
        );
    } else {
      let retObj: any;
      this.dataServiceObj = {};
      if (this.isAggregationBucket === "true") {
        this.genericAggregator = new platFormLib[this._genericService.appTitle](
          this._genericService.appTitle
        );
        this.dataServiceObj = this.genericAggregator.aggregationImpl(
          retObj,
          this.shouldAggregate,
          this._genericService,
          this._aggregationService,
          this.isAggregationBucket,
          this._analyticService
        );
      }
    }
    this.tname = this.templateName;
  }
}
